import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { supportedLanguages, getPathWithoutLanguage, getLocalizedPath } from '@/i18n/config';

const BASE_URL = 'https://voya-ai.lovable.app';

export const HreflangTags = () => {
  const location = useLocation();
  const cleanPath = getPathWithoutLanguage(location.pathname);

  return (
    <Helmet>
      {/* Default/canonical for English */}
      <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}${cleanPath}`} />
      
      {/* All supported languages */}
      {supportedLanguages.map((lang) => {
        const localizedPath = getLocalizedPath(cleanPath, lang.code);
        return (
          <link
            key={lang.code}
            rel="alternate"
            hrefLang={lang.code}
            href={`${BASE_URL}${localizedPath}`}
          />
        );
      })}
    </Helmet>
  );
};
